<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Rückmeldung senden"}}</h4>
</div>

<div class="modal-body">
    <div class="form-group">
        <label for="feedback-category" class="control-label">{{TR "Kategorie"}}</label>
        <select id="feedback-category" name="feedback-category" class="selectpicker" data-style="btn-white">
        {{#each categories}}
            <option value="{{id}}">{{ name }}</option>
        {{/each}}
        </select>
    </div>
    <div class="form-group">
        <label for="feedback-content" class="control-label">{{TR "Ihre Rückmeldung"}}</label>
        <textarea class="form-control" name="feedback-content" id="feedback-content"></textarea>
        <div class="checkbox checkbox-primary m-t-15">
            <input id="feedback-to-user" type="checkbox" autocomplete="off" />
            <label for="feedback-to-user">{{TR "Kopie an mich senden"}}</label>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button class="btn btn-primary" disabled id="feedback-send">
        {{TR "Senden"}}
    </button>
</div>
